const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/zustaendigkeit.ts';
import moment from 'moment';
import { KISIM_TIME_FORMAT } from '@cistec/common_web/defs/generalDefs';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';
import { PATAPI } from 'App/middleware/patapi';
import { apiLoadResponsibilitiesByPat } from '@cistec/common_web/actions/kisapi/responsibilities';

export const REQUEST_ACTION_TYPES_LOAD_PAT_RESPONSIBILITIES = kisapiActionTypes('LOAD_PAT_RESPONSIBILITIES');

/**
 * Action to load the responsibilities assigned to any user for the given patient
 * @param patnr (in): the patient whose responsibilities are to be loaded
 * @param fallnr (in): the case number of that patient
 * @param mindat (in): min of the time interval the responsibility objects must overlap; YYYY-MM-DD HH:mm:ss
 * @param maxdat (in): max of the time interval the responsibility objects must overlap; YYYY-MM-DD HH:mm:ss
 * @param withContent (in): true=load CONTENT of responsibility object
 * @param callerId (in): Optional metadata to identify the calling instance
 */
export function loadPatResponsibilities(
    patnr: string,
    fallnr: string,
    mindat?: string,
    maxdat?: string,
    withContent: boolean = false,
    callerId?: string
) {
    const now = moment().format(KISIM_TIME_FORMAT);

    return {
        type: REQUEST_ACTION_TYPES_LOAD_PAT_RESPONSIBILITIES.combined,
        [PATAPI]: apiLoadResponsibilitiesByPat(patnr, fallnr, mindat || now, maxdat || now, withContent),
        meta: {
            fallnr,
            mindat: mindat || now,
            maxdat: maxdat || now,
            callerId,
            showDlgWhenResultHasMoreRows: true,
        },
    };
}
